import React, { useState } from "react";

import { useForm } from "react-hook-form";



const WalkInForm = () => {

    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();




    const applyWalkInInterview = async (data) => {



        const resumeFile = data.resume?.[0];
        if (!resumeFile) return;

        const experience =
            data.experience === "custom"
                ? data.customExperience
                : data.experience;

        const formData = new FormData();
        formData.append("wi_name", data.name);
        formData.append("wi_number", data.mobile);
        formData.append("wi_email", data.email);
        formData.append("wi_address", data.address);
        formData.append("wi_experience", experience);
        formData.append("wi_position", "Walk-in Interview");
        formData.append("wi_resume", resumeFile);

        try {
            setLoading(true);

            const res = await fetch(
                "https://api.visko.group/api/crm/walking-interview/apply-job-from-qr",
                {
                    method: "POST",
                    body: formData,
                }
            );

            await res.json();


            if (res.ok) {
                reset();
                setShowSuccess(true); // ✅ SUCCESS UI
            }
        } catch (err) {
            console.error("Walk-in Apply Error:", err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div
            className="container-fluid d-flex align-items-center justify-content-center"
            style={{ minHeight: "100vh", padding: "10px" }}
        >
            <div
                className="card shadow-lg w-100"
                style={{
                    maxWidth: "550px",
                    borderRadius: "18px",
                    border: "none",
                }}
            >
                {showSuccess ? (
                    /*  SUCCESS SCREEN */
                    <div className="text-center p-5">
                        <div style={{ fontSize: "60px", color: "#28a745" }}>

                        </div>
                        <h3 className="fw-bold text-success mt-3">
                            Form Submitted Successfully
                        </h3>
                        <p className="text-muted mt-2">
                            Our HR team will contact you soon.
                        </p>
                    </div>
                ) : (

                    <>
                        {/* Header */}
                        < div className="text-center" style={{ padding: "25px" }}>
                            <h4 className="fw-bold fs-2 text-black mb-2">Walk-in Interview</h4>
                            <p className="text-muted small mb-2">
                                50+ Openings Across Departments
                            </p>

                            <div className="d-flex flex-column text-black flex-md-row justify-content-center gap-2 small">
                                <span>Indore</span>
                                <span>11 AM – 4 PM (Mon–Sat)</span>
                            </div>
                        </div>

                        {/* Form */}
                        <div className="card-body p-4">
                            <form onSubmit={handleSubmit(applyWalkInInterview)}>
                                {/* Name */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Full Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                        placeholder="Enter your full name"
                                        {...register("name", {
                                            required: "Full name is required",
                                            pattern: {
                                                value: /^[A-Za-z\s]+$/,
                                                message: "Only letters allowed",
                                            },
                                        })}
                                    />
                                    <small className="text-danger">{errors.name?.message}</small>
                                </div>

                                {/* Mobile */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Mobile Number <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="tel"
                                        placeholder="10 digit number"
                                        {...register("mobile", {
                                            required: "Mobile number is required",
                                            pattern: {
                                                value: /^[0-9]{10}$/,
                                                message: "Enter valid 10 digit number",
                                            },
                                        })}
                                        style={{ borderRadius: "10px" }}
                                    />
                                    {errors.mobile && (
                                        <small className="text-danger">{errors.mobile.message}</small>
                                    )}
                                </div>

                                {/* Email */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Email Address <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        placeholder="example@email.com"
                                        {...register("email", {
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: "Enter a valid email address",
                                            },
                                        })}
                                        style={{ borderRadius: "10px" }}
                                    />
                                    {errors.email && (
                                        <small className="text-danger">{errors.email.message}</small>
                                    )}
                                </div>

                                {/* Address */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Address <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        placeholder="Your area / city"
                                        {...register("address", {
                                            required: "Address is required",
                                            minLength: {
                                                value: 5,
                                                message: "Address is too short",
                                            },
                                        })}
                                        style={{ borderRadius: "10px" }}
                                    />
                                    {errors.address && (
                                        <small className="text-danger">{errors.address.message}</small>
                                    )}
                                </div>

                                {/* Experience */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Experience <span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className="form-select"
                                        {...register("experience", {
                                            required: "Experience is required",
                                        })}
                                        style={{ borderRadius: "10px" }}
                                    >
                                        <option value="">Select Experience</option>
                                        <option value="Fresher">Fresher</option>
                                        <option value="1-2 Years">1 – 2 Years</option>
                                        <option value="3-5 Years">3 – 5 Years</option>
                                        <option value="5+ Years">5+ Years</option>
                                        <option value="custom">Custom</option>
                                    </select>

                                    {errors.experience && (
                                        <small className="text-danger">{errors.experience.message}</small>
                                    )}
                                </div>

                                {/* Custom Experience (Hidden by default) */}
                                {watch("experience") === "custom" && (
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold  text-black">
                                            Enter Your Experience <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            className="form-control"
                                            placeholder="e.g. Years "
                                            {...register("customExperience", {
                                                required: "Please enter your experience",
                                            })}
                                            style={{ borderRadius: "10px" }}
                                        />
                                        {errors.customExperience && (
                                            <small className="text-danger">-
                                                {errors.customExperience.message}
                                            </small>
                                        )}
                                    </div>
                                )}

                                {/* Resume Upload */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold text-black">
                                        Upload Resume <span className="text-danger">*</span>
                                    </label>

                                    <input
                                        type="file"
                                        className="form-control"
                                        accept=".pdf,.doc,.docx"
                                        {...register("resume", {
                                            required: "Resume is required",
                                            validate: {
                                                fileType: (files) =>
                                                    files?.length &&
                                                    [
                                                        "application/pdf",
                                                        "application/msword",
                                                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                    ].includes(files[0].type) ||
                                                    "Only PDF or DOC files allowed",
                                            },
                                        })}
                                        style={{ borderRadius: "10px" }}
                                    />

                                    {errors.resume && (
                                        <small className="text-danger">{errors.resume.message}</small>
                                    )}
                                </div>

                                {/* Info */}
                                <div
                                    className="mb-3"
                                    style={{
                                        background: "#FFF3ED",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        fontSize: "13px",
                                    }}
                                >
                                    Your information is safe and confidential. We only use it for
                                    recruitment purposes.
                                </div>

                                {/* Submit */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="btn w-100 text-white fw-bold"
                                    style={{
                                        background: loading ? "#ccc" : "#ff6a00",
                                        padding: "12px",
                                        borderRadius: "12px",
                                    }}
                                >
                                    {loading
                                        ? "Submitting..."
                                        : "Register for Walk-in Interview"}
                                </button>
                            </form>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};


export default WalkInForm;

/* ================= STYLES ================= */

const styles = {
    overlay: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "16px",
    },

    card: {
        width: "100%",
        maxWidth: "420px",
        backgroundColor: "#fff",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
    },

    header: {
        backgroundColor: "#FFF3ED",
        padding: "20px",
        textAlign: "center",
        position: "relative",
    },

    close: {
        position: "absolute",
        right: "16px",
        top: "10px",
        fontSize: "22px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
    },

    title: {
        margin: 0,
        fontSize: "20px",
        fontWeight: "700",
    },

    subTitle: {
        fontSize: "13px",
        color: "#666",
        marginTop: "4px",
    },

    infoRow: {
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        fontSize: "12px",
        marginTop: "10px",
        color: "#555",
    },

    form: {
        padding: "20px",
    },

    field: {
        marginBottom: "14px",
    },

    label: {
        fontSize: "13px",
        fontWeight: "500",
    },

    input: {
        width: "100%",
        padding: "10px 12px",
        marginTop: "6px",
        borderRadius: "8px",
        border: "1px solid #ddd",
        outline: "none",
        fontSize: "14px",
    },

    uploadBox: {
        marginTop: "8px",
        border: "2px dashed #ddd",
        borderRadius: "8px",
        padding: "14px",
        textAlign: "center",
        fontSize: "13px",
        color: "#666",
        cursor: "pointer",
    },

    helperText: {
        fontSize: "11px",
        color: "#888",
        marginTop: "6px",
    },

    optional: {
        color: "#999",
        fontSize: "12px",
    },

    infoBox: {
        backgroundColor: "#FFF3ED",
        padding: "10px",
        fontSize: "11px",
        borderRadius: "8px",
        color: "#555",
        marginBottom: "16px",
    },

    submitBtn: {
        width: "100%",
        padding: "12px",
        backgroundColor: "#F97316",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontSize: "15px",
        fontWeight: "600",
        cursor: "pointer",
    },
};